/**************************************************
 * Nombre:       Home_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Button, Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_portada.mp4'
import img_fondo from '../../../Recursos/img_fondo.png'
import {useNavigate} from "react-router-dom";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";
import cafe_color from '../../../Recursos/cafe_color.svg'
import cafe_blanco from '../../../Recursos/cafe_blanco.svg'
import {iniciarChatWass} from "../../../Utilidades/iniciarChatWass";
import {useIrRuta} from "../../../Utilidades/useIrRuta";
import {SECCIONES} from "../../../Constantes";

const Home_Portada = () => {
    const navigate = useNavigate();
    const {sCell} = useResponsive()
    const {ir} = useIrRuta()

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <video width={'100%'} height={sCell ? 580 : 640}
                   style={{
                       objectFit: 'cover',
                       zIndex: 1,
                       //   backgroundImage: `url(${img_fondo})`,
                       backgroundPosition: 'center',
                       backgroundSize: 'cover'
                   }}
                   id="background-video" autoPlay loop muted poster={img_fondo}>

                <source src={fondo} type="video/mp4"/>

            </video>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-end'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{
                    marginTop: sCell ? -70 : -82,
                    zIndex: 2,
                    background: `linear-gradient(180deg, rgba(32, 32, 32, 0.67) 8.57%, rgba(32, 32, 32, 0.35) 22.93%, #202020 87.8%, #202020 96.61%)`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    backgroundRepeat: 'no-repeat',
                    minHeight: sCell ? 580 : 656
                }}

            >

                <Grid container size={{xs: 12, sm: 12, md: 11}}
                      sx={{justifyContent: 'flex-start', maxWidth: '1400px', px: 3}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}
                        sx={{py: sCell ? 3 : 10, color: '#fff'}}
                    >

                        <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-start'}}>
                            <Typography sx={{
                                fontSize: sCell ? 32 : 48,
                                fontWeight: 700,
                                lineHeight: 1.2,
                                textAlign: sCell ? 'center' : 'left'
                            }}>Del origen a tu taza, con
                                trazabilidad y
                                propósito</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 7}} sx={{justifyContent: 'flex-start', mt: 2}}>
                            <Typography sx={{fontSize: 20, fontWeight: 400, textAlign: sCell ? 'center' : 'left'}}>
                                “Acompañamos cada etapa asegurando trazabilidad, procesos limpios y responsables que
                                reflejan el verdadero espíritu del café especia
                            </Typography>
                        </Grid>

                        <Grid container size={12} sx={{justifyContent: 'flex-start', mt: 6}}>
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={ sCell ? 2 :4}
                            >

                                <Button
                                    color={'secondary'}
                                    onClick={() => ir('Contactos')}
                                    startIcon={<img src={cafe_color} width={32} height={32}/>}
                                >
                                    <Typography>Contactos</Typography>
                                </Button>

                                {/*<Button
                                    color={'secondary'}
                                    variant="outlined"
                                    onClick={() => iniciarChatWass({mensaje: 'Hola, quieros saber mas de sus fincas'})}
                                    startIcon={<img src={cafe_blanco} width={32} height={32}/>}
                                >
                                    <Typography>Nuestras Fincas</Typography>
                                </Button>*/}

                            </Grid>

                        </Grid>


                    </Grid>
                </Grid>


            </Grid>

        </Grid>
    )

}
export default Home_Portada    